const serviceUrl = 'https://aloxa.ai/flaskservice/'

export const postApi = async (url, params) => {
  let myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  let payload = {
    method: 'POST',
    body: JSON.stringify(params),
    headers: myHeaders
  };

  const response = await fetch(`${serviceUrl}${url}`, payload);
  const data = await response.json();
  return data;
};
